<template>
  <v-container fluid class="authentication-view">
    <v-row>
      <v-col cols="6">
        <v-btn @click="startLogin" v-if="!isAuthenticated"> Login </v-btn>
        <v-btn class="ml-3" @click="startLogout" v-else> Logout </v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn @click="sendQuery">Try Query Backend</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="isAuthenticated">
      <v-col cols="6">
        <h2>User</h2>
        <ul>
          <li>
            <strong>First Name</strong>
            <span class="ml-2">{{ user.given_name }}</span>
          </li>
          <li>
            <strong>Last Name</strong>
            <span class="ml-2">{{ user.family_name }}</span>
          </li>
          <li>
            <strong>Principal ID</strong>
            <span class="ml-2">{{ user.ppid }}</span>
          </li>
          <li>
            <strong>email</strong>
            <span class="ml-2">{{ user.email }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2>Authentication directives</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h3>All Divisions</h3>
        <div class="ma-2">
          <v-btn v-role:admin>Admin - All Divisions</v-btn>
        </div>
        <div class="ma-2">
          <v-btn v-role:contrib>Contrib - All Divisions</v-btn><br />
        </div>
        <div class="ma-2">
          <v-btn v-role:viewer>Viewer - All Divisions</v-btn><br />
        </div>
      </v-col>
      <v-col>
        <h3>3DIV</h3>
        <div class="ma-2">
          <v-btn v-role:admin="'3div'">Admin - 3DIV</v-btn>
        </div>
        <div class="ma-2">
          <v-btn v-role:contrib="'3div'">Contrib - 3DIV</v-btn>
        </div>
        <div class="ma-2">
          <v-btn v-role:viewer="'3div'">Viewer - 3DIV</v-btn>
        </div>
      </v-col>
      <v-col>
        <h3>FBP</h3>
        <div class="ma-2">
          <v-btn v-role:admin="'fbp'">Admin - FBP</v-btn>
        </div>
        <div class="ma-2">
          <v-btn v-role:contrib="'fbp'">Contrib - FBP</v-btn>
        </div>
        <div class="ma-2">
          <v-btn v-role:viewer="'fbp'">Viewer - FBP</v-btn>
        </div>
      </v-col>
      <v-col>
        <h3>FBP &amp; FSH</h3>
        <div class="ma-2">
          <v-btn v-role:admin="'fbp,fsh'">Admin - FBP &amp; FSH</v-btn>
        </div>
        <div class="ma-2">
          <v-btn v-role:contrib="'fbp,fsh'">Contrib - FBP &amp; FSH</v-btn>
        </div>
        <div class="ma-2">
          <v-btn v-role:viewer="'fbp,fsh'">Viewer - FBP &amp; FSH</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('authentication')
import axios from '@/utils/axios'
import config from '@/utils/config'

export default {
  components: {},
  name: 'Authentication',
  data() {
    return {}
  },
  methods: {
    ...mapActions(['startLogin', 'startLogout']),
    async sendQuery() {
      const { data } = await axios.get(`${config.BACKEND_BASE_URL}/secure`)
      console.log(data)
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'user'])
  }
}
</script>

<style></style>
